import { usePipelinePreload } from '../../providers';
export const useRecordCardProperties = () => {
  const store = usePipelinePreload();
  return store.cardProperties;
};